import { Box, Card, Grid, TextField } from "@mui/material"
import { Formik } from "formik"
import Button from "components/Button"
import { ReportTypeEnum } from "../../interfaces/reports.interfaces"
import { ChosenFields } from "./ChosenFields"
import { FieldsToChoose } from "./FieldsToChoose"
import { PeopleAccessList } from "./PeopleAccessList"
import { templateValidationSchema } from "./templateValidationSchema"
import { useTranslation } from "react-i18next"

const TemplateForm = ({
  submitFeedbackResult,
  addFormTemplate,
  editTemplate,
  onSubmit,
  deleteTemplate,
  editMode,
  reportType
}: any) => {
  const initialValues = editMode ? editTemplate : addFormTemplate
  const { t } = useTranslation()
  const handleSubmit = async (values: any, { resetForm }: any) => {
    onSubmit(values)
  }

  return (
    <Formik
      onSubmit={handleSubmit}
      validateOnChange={false}
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={templateValidationSchema}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue
      }: any) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid container direction="row" justifyContent="flex-end" spacing={2}>
            <Grid item xs={12} md={5}>
              <Box marginBottom={2}>
                <FieldsToChoose onChange={handleChange} onBlur={handleBlur} setFieldValue={setFieldValue} />
              </Box>
            </Grid>

            <Grid item xs={12} md={7}>
              <ChosenFields />
              <Box component={Card} paddingX={2} paddingY={3} marginTop={2}>
                <Grid container spacing={2} direction="row">
                  <Grid item xs={12}>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      id="name"
                      label={t("reports.name_of_report", "Name of report")}
                      value={values?.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.name && errors.name ? true : false}
                      helperText={touched.name && errors.name ? t("global.name_is_required", "Name is required") : null}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      id="description"
                      label={t("reports.descriptive_text", "Descriptive text")}
                      value={values?.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </Box>
              {reportType === ReportTypeEnum.User && (
                <PeopleAccessList reportType={reportType} />
              )}
            </Grid>

          </Grid>
          <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={5}>
            <Grid item>
              {editMode && (
                <Box marginTop={3}>
                  <Button color="primary" variant="outlined" onClick={() => deleteTemplate()}>
                    {t("reports.remove_report_template", "Remove report template")}
                  </Button>
                </Box>
              )}
            </Grid>
            <Grid item>
              <Box marginTop={3}>
                <Button color="primary" type="submit" result={submitFeedbackResult}>
                  {editMode ? t("global.update", "Update") : t("global.save", "Save")}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  )
}

export default TemplateForm